module.exports = __webpack_public_path__ + "static/media/INFY_F1.1823b526.txt";